<template>
  <div>
    <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>

    <!-- 
      @handleSelectionChange="bachOper" 
      :tableOption="tableOption"
    -->
    <ots-table-group-new
      :selectList="selectList"
      :requestForm="requestForm"
      :tableHeader="tableHeader"
      :tableData="tableData"
      :pagination="pagination"
      @changeNum="changeNum"
      @changePage="changePage"
      @search="search"
    ></ots-table-group-new>

    <!-- <ots-custom-dialog :dialog.sync="showSheetDialog" title="查看签到表" width="40%">
      <template v-slot:content>
        <div class="QRBox">
          <img :src="sheetImage" alt="">
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="showSheetDialog = false">关闭</el-button>
      </template>
    </ots-custom-dialog> -->

    <ots-custom-dialog :dialog.sync="signDialog" title="上传纸质单据">
      <template v-slot:content>
        <div>
          <el-form inline label-width="100px">
            <div>
              <el-form-item>
                <el-upload
                  class="upload-demo"
                  action=""
                  :on-remove="handleRemove"
                  :on-change="handleSuccess"
                  :file-list="fileList"
                  :before-upload="beforeAvatarUpload" 
                  :http-request="uploadImg"
                  list-type="picture">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
            </div>
            <div></div>
          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="signDialog = false">取消</el-button>
        <el-button round type="primary" @click="setSign">确定</el-button>
      </template>
    </ots-custom-dialog>

    <ots-custom-dialog :dialog.sync="showSheetDialog" title="查看纸质单据" width="80%">
      <template v-slot:content>
        <div class="dialogImg">
        <div
          v-for="(item, key) in singSheetImgList"
          :key="key"
          class="disciplineImg"
        >
          <img :src="item" alt="" />
        </div>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="showSheetDialog = false">关闭</el-button>
      </template>
    </ots-custom-dialog>

  </div>
</template>

<script>
import { getSelectPlanFn } from "@/http/modules/examSet/examBatch";
import { getCurrentSelectPlace } from "@/http/modules/examSet/planClass";
import { tryExamSelectClassAPI, exportClassSignTableAPI, getPlanClassSignTableListAPI, uploadClassSignTableAPI, getPlanPlaceListAPI } from "@/http/modules/computedRoomExam";

export default {
  data() {
    return {
      mainTopBtnList: [
        {
          title: "导出",
          fn: this.exportInfo,
        },
      ],
      tableOption: {
        multiple: true,
      },
      selectList: [
        {
          title: "批次名称",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: '考点名称',
          type: 'select',
          requestKey: 'placeId',
          label: 'name',
          value: 'id',
          data: [],
        },
        {
          title: '教室名称',
          type: 'select',
          requestKey: 'classId',
          label: 'name',
          value: 'id',
          data: [],
        },
      ],
      pagination: {
        total: 0,
      },
      tableData: [],
      tableHeader: [
        {
          title: "批次名称",
          prop: "planName",
        },
        {
          title: "考点名称",
          prop: "placeName",
        },
        {
          title: "场次",
          prop: "sessionName"
        },
        {
          title: "教室名称",
          prop: "className",
        },
        {
          title:"纸质单据",
          type:"buttons",
          width:"100",
          btnList:[
            { title:"查看", click: this.showSheet, formatter: (scope) => { return !scope.row.signTableUrl } },
            { title:"上传", click: this.uploadSheet, 
            // formatter: (scope) => { return scope.row.signTableUrl != null } 
            },
          ]
        }
      ],
      requestForm: {
        planId: '',
        placeId: '',
        classId: '',
        size: 10,
        page: 1,
      },

      showSheetDialog: false,
      sheetImage: '',

      fileList: [],
      signDialog: false,
      uploadForm: {
        planId: '',
        placeId: '',
        classId: '',
        base64List: '',
      },
      singSheetImgList: [],
    }
  },
  watch: {
    'requestForm.planId': function(value) {
      this.getPlace(value);
      this.getTableData();
    },
    'requestForm.placeId': function(value) {
      this.getClass(value);
    },
    // "signDialog": function(value) {
    //   // 清空 照片列表
    //   if (!value) {
    //     this.fileList = [];
    //   }
    // }
  },
  created() {
    this.getPlan();
  },
  methods: {
    // 查询
    search() {
      this.requestForm.page = 1;
      this.getTableData();
    },

    uploadSheet(row) {
      this.uploadForm.planId = row.planId;
      this.uploadForm.placeId = row.placeId;
      this.uploadForm.classId = row.classId;
      this.uploadForm.sessionId = row.sessionId;

      this.fileList = [];

      if (row.signTableUrl) {
        row.signTableUrl.split(",").map(e=>{
          let item = {
            name: "",
            url: e
          }
          this.fileList.push(item);
        })
      }

      this.$nextTick(() => {
        this.signDialog = true;
      })

    },

    // 批量上传
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    handleSuccess(file, fileList) {
      this.fileList = fileList;
    },
    // 未配置 action, 覆盖一下默认上传行为
    uploadImg(data) {
      let that = this;
      let fileData = data.file;
      let reader = new FileReader();
      reader.readAsDataURL(fileData);
      reader.onload = function (e) {
        if (e.currentTarget.result) {
          that.fileList.map((item, index)=> {
            if (item.name == data.file.name) {
              that.fileList[index].url = e.currentTarget.result;
            }
          })
        }
      };
    },

    setSign() {
      let photoList = this.fileList.map(e => { 

        if (e.name) {
          return e.url.split(',')[1] 
        } else {
          return e.url;
        }

      });
      this.uploadForm.base64List = photoList.join(",");
      const params = { ...this.uploadForm };
      uploadClassSignTableAPI(params).then((res) => {
        if (res.code == 1) {
          this.$message.success("操作成功");
          this.getTableData();
          this.signDialog = false;
        }
      });
    },
    beforeAvatarUpload(fileData) {
      let ImgRules = ["jpg", "jpeg", "png"]
      let type = fileData.name.substring(fileData.name.lastIndexOf(".") + 1);
      const isJPG = ImgRules.indexOf(type) !== -1;
      const isLt30kb = fileData.size / 1024 < 2048;
      if (!isJPG && !isLt30kb) {
        this.$message.error(`该批次上传图片只能是 "jpg", "jpeg", "png" 格式，且大小不能超过 2048 kb! `);
      } else if (!isJPG) {
        this.$message.error(`该批次上传图片只能是 "jpg", "jpeg", "png" 格式!`);
      } else if (!isLt30kb) {
        this.$message.error(`该批次上传图片大小不能超过 2048 kb!`);
      }
      return isJPG && isLt30kb;
    },


    bachOper(val) {
      console.log("勾选");
      let idList=[]
      // val.forEach(item=>{ idList.push(item.id) })
      // let selectIds = idList
      // console.log(selectIds)
    },

    // 获取批次
    async getPlan() {
      const { data: planData } = await getSelectPlanFn({needAudit: 31});
      this.selectList[0].data = planData;
      this.requestForm.planId = planData[0].id;
    },

    // 获取考点
    async getPlace(value) {
      // const { data: placeData } = await getCurrentSelectPlace({planId: value});
      const { data: placeData } = await getPlanPlaceListAPI({planId: value});
      if (!placeData) {
        this.selectList[1].data = [];
        this.requestForm.placeId = '';
        return;
      }
      this.selectList[1].data = [{id: '', name: '全部'}, ...placeData];
      this.requestForm.placeId = "";
    },

    // 获取教室
    async getClass(id) {
      if (id) {
        this.selectList[1].data.map(e=>{
          if (e.id == id) {
            if (e.placeClassList.length === 0) {
              this.selectList[2].data = [];
              this.requestForm.classId = '';
              return;
            }
            this.selectList[2].data = [{id: '', name: '全部'}, ...e.placeClassList];
            this.requestForm.classId = '';
            return;
          }
        })
      } else {
        this.selectList[2].data = [];
        this.requestForm.classId = "";
      }

      // return;
      // let params = {
      //   planId: this.requestForm.planId,
      //   placeId: this.requestForm.placeId
      // }
      // const { data: classData } = await tryExamSelectClassAPI(params);
      // if (classData.length === 0) {
      //   this.selectList[2].data = [];
      //   this.requestForm.classId = '';
      //   return;
      // }
      // this.selectList[2].data = [{id: '', name: '全部'}, ...classData];
      // this.requestForm.classId = '';
    },

    // 获取表格数据
    async getTableData() {
      let params = { ...this.requestForm };
      const { data: tableData } = await getPlanClassSignTableListAPI(params);
      this.pagination.total = tableData.total;
      this.tableData = tableData.records;
    },

    // 导出
    async exportInfo() {
      let params = { ...this.requestForm };
      let result = await exportClassSignTableAPI(params);
      if (result.code === 1) {
        window.open(result.data);
      }
    },

    // 查看签到表
    showSheet(row) {
      this.sheetImage = row.signTableUrl;
      this.singSheetImgList = row.signTableUrl.split(",");
      console.log(this.singSheetImgList.length)
      this.showSheetDialog = true;
    },

    changeNum(num) {
      this.requestForm.size = num
      this.getTableData()
    },

    changePage(p) {
      this.requestForm.page = p;
      this.getTableData();
    },
  }

}
</script>

<style scoped lang="less">
.QRBox {
  img {
    width: 100%;
  }
}
.dialogImg {
  display: flex;
  flex-flow: row wrap;
  margin-left: 8%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.disciplineImg {
  padding: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  img {
    max-width: 100%;
    // height: 162px;
  }
}
</style>